import axios from "axios";
import auth from "./auth";

// Needed so the browser stores/sends cookies set by the auth endpoints
axios.defaults.withCredentials = true;

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    console.error("An unexpected error occured.");
  }

  // Session expired / revoked: drop it and send the user back to login
  if (error.response?.status === 401 && auth.getJWT()) {
    auth.clearSession();
    window.location.assign("/");
  }

  return Promise.reject(error);
});

axios.interceptors.request.use(
  function (config) {
    const token = auth.getJWT();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
};

export default http;
